import React from "react";
import Title from "./app/Title";
import Breadcrumbs from "./app/Breadcrumbs";
import Page from "./app/Page";
import MessageBox from "../containers/app/MessageBox";
import LogoutButton from "./app/LogoutButton";
import Loader from "./app/Loader";
import { Stages } from "../actions/actions";
export default class OscApp extends React.Component {
  componentDidMount() {
    this.props.onIsCalProvider();
  }

  render() {
    let {
      stage,
      focusOn,
      isConnected,
      source,
      setPopulateCards,
      onSetLoader,
      selectCard,
      logoutMessage,
      isLoading,
      isMenuOpen,
      onSetStage,
      onOpenMenu,
      onOpenLogoutMessage,
      onFocus,
      onCloseLogoutMessage,
      onLogout,
      onSessionExpiredLogout,
      onSessionExpiredExit,
      onExit,
      isCalProvider,
      provider,
      setError,
      onGoBack,
      gotToCardsPage,
    } = this.props;

    const getPageClass = () => {
      if (stage == Stages.login) {
        return "bg-grad login";
      } else if (stage == Stages.thankYou) {
        return "bg-grad thankYou";
      } else {
        return "bg-grad";
      }
    };

    const getLogoutButton = () => {
      if (isConnected)
        return <LogoutButton onLogout={onOpenLogoutMessage} stage={stage} />;
      return null;
    };

    const openLogoutMessage = () => {
      if (
        (logoutMessage && logoutMessage.text) ||
        (logoutMessage && logoutMessage.logoutFirstText)
      ) {
        if (logoutMessage.url) {
          return (
            <MessageBox
              text={logoutMessage.text}
              onCancel={onCloseLogoutMessage}
              provider={provider}
              onOk={() => onExit(logoutMessage.url, true)}
              okText="המשך"
            />
          );
        } else {
          if (logoutMessage.sessionExpired) {
            return (
              <MessageBox
                text={
                  <div className="text-msg">
                    <span>{logoutMessage.text[0]}</span>
                    <span>{logoutMessage.text[1]}</span>
                  </div>
                }
                htmlText={true}
                topImg={logoutMessage.topImg}
                onCancel={() => onSessionExpiredLogout()}
                onOk={() => onSessionExpiredExit()}
                okText={logoutMessage.okText}
                cancelText={logoutMessage.cancelText}
              />
            );
          } else {
            return (
              <MessageBox
                text={
                  <div className="text-msg">
                    <span>{logoutMessage.text[0]}</span>
                    <span>{logoutMessage.text[1]}</span>
                  </div>
                }
                htmlText={true}
                topImg={logoutMessage.topImg}
                onCancel={onCloseLogoutMessage}
                onOk={() => onLogout(logoutMessage)}
                okText={logoutMessage.okText}
                cancelText={logoutMessage.cancelText}
              />
            );
          }
        }
      }
      return null;
    };

    const getBreadcrumbs = () => {
      if (stage !== Stages.welcome && stage != Stages.thankYou) {
        return (
          <Breadcrumbs
            stage={stage}
            provider={provider}
            role="navigation"
            focusOn={focusOn}
            onFocus={onFocus}
          />
        );
      }
      return null;
    };

    const setLoader = () => {
      if (isLoading) {
        return <Loader />;
      }
      return null;
    };

    return (
      <div id="osc-wrapper">
        <Title
          isConnected={isConnected}
          isMenuOpen={isMenuOpen}
          onOpenMenu={onOpenMenu}
          onLogout={onOpenLogoutMessage}
          onExit={onExit}
          stage={stage}
          focusOn={focusOn}
          onFocus={onFocus}
          isCalProvider={isCalProvider}
          provider={provider}
          onGoBack={onGoBack}
          gotToCardsPage={gotToCardsPage}
        />

        {getBreadcrumbs()}

        <div id="page-wrap" role="main" className={getPageClass()}>
          <Page
            stage={stage}
            isConnected={isConnected}
            source={source}
            setPopulateCards={setPopulateCards}
            selectCard={selectCard}
            onSetStage={onSetStage}
            onSetLoader={onSetLoader}
            setError={setError}
            provider={provider}
          />
          {getLogoutButton()}
        </div>
        <div aria-live="assertive">{setLoader()}</div>
        {openLogoutMessage()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OscApp.jsx